var _style, _g, _path, _line, _line2, _path2, _path3, _polygon, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValentin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 503.13 135.42",
    style: {
      enableBackground: "new 0 0 503.13 135.42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D0033F;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.3,29.22l5.68,17.76c1.01,3.09,1.73,5.9,2.37,8.77h0.22c0.65-2.88,1.44-5.61,2.37-8.77l5.61-17.76h9.28 l-13.37,35.02h-8.7l-13.01-35.02H256.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.97,55.83c0,3.16,0.14,6.26,0.57,8.41h-7.98l-0.65-3.88h-0.22c-2.08,2.73-5.75,4.67-10.35,4.67 c-7.05,0-11-5.1-11-10.43c0-8.77,7.84-13.3,20.78-13.23V40.8c0-2.3-0.94-6.11-7.12-6.11c-3.45,0-7.05,1.08-9.42,2.59l-1.73-5.75 c2.59-1.58,7.12-3.09,12.65-3.09c11.22,0,14.45,7.12,14.45,14.81V55.83z M305.34,47.13c-6.25-0.07-12.22,1.22-12.22,6.54 c0,3.45,2.23,5.03,5.03,5.03c3.59,0,6.11-2.3,6.97-4.82c0.21-0.65,0.21-1.29,0.21-1.94V47.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.31,13.19h8.84v51.05h-8.84V13.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.04,49.21c0.22,6.33,5.1,9.06,10.78,9.06c4.1,0,6.97-0.65,9.71-1.58l1.29,6.04 c-3.02,1.29-7.19,2.23-12.22,2.23c-11.36,0-18.05-6.97-18.05-17.69c0-9.71,5.9-18.84,17.11-18.84c11.36,0,15.1,9.35,15.1,17.04 c0,1.65-0.14,2.95-0.29,3.74H348.04z M363.43,43.03c0.07-3.24-1.37-8.56-7.26-8.56c-5.46,0-7.76,4.96-8.12,8.56H363.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.89,39.65c0-4.03-0.14-7.41-0.29-10.43h7.69l0.43,5.25h0.22c1.58-2.73,5.39-6.04,11.22-6.04 c6.11,0,12.44,3.95,12.44,15.03v20.78h-8.84V44.47c0-5.03-1.87-8.84-6.69-8.84c-3.52,0-5.97,2.52-6.9,5.18 c-0.29,0.72-0.43,1.8-0.43,2.8v20.64h-8.84V39.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429.79,20.24v8.99h8.41v6.61h-8.41V51.3c0,4.31,1.15,6.47,4.53,6.47c1.58,0,2.44-0.07,3.45-0.36l0.14,6.69 c-1.29,0.5-3.67,0.94-6.4,0.94c-3.31,0-5.97-1.08-7.62-2.88c-1.94-2.01-2.8-5.25-2.8-9.85V35.84h-4.96v-6.61h4.96v-6.54 L429.79,20.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.31,19.45c0,2.59-1.94,4.75-5.03,4.75c-2.95,0-4.89-2.16-4.89-4.75c0-2.73,2.01-4.82,4.96-4.82 C452.37,14.63,454.24,16.71,454.31,19.45z M444.89,64.24V29.22h8.84v35.02H444.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.3,39.65c0-4.03-0.14-7.41-0.29-10.43h7.69l0.43,5.25h0.22c1.58-2.73,5.39-6.04,11.22-6.04 c6.11,0,12.44,3.95,12.44,15.03v20.78h-8.84V44.47c0-5.03-1.87-8.84-6.69-8.84c-3.52,0-5.97,2.52-6.9,5.18 c-0.29,0.72-0.43,1.8-0.43,2.8v20.64h-8.84V39.65z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179,119.03c3.92-5.18,7.17-10.09,10.3-15.16c6.64-10.81,14.38-16.34,23.74-10.55 c9.01,5.58,15.31,10.9,16.35,11.48V21.86c0-7.79-6.33-14.11-14.13-14.11H22.42c-7.81,0-14.13,6.32-14.13,14.11v90.84 c0,7.79,6.33,14.11,14.13,14.11h149.27C172.29,126.3,175.8,123.26,179,119.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.4872,
    y1: 84.1402,
    x2: 230.2728,
    y2: 105.5309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2442,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4653,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6776,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8831,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B2B2"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 229.39,
    y1: 103.03,
    x2: 229.39,
    y2: 103.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.565,
    y1: 109.8316,
    x2: 171.7494,
    y2: 126.823
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2442,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4653,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6776,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8831,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B2B2"
    }
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 171.79,
    y1: 126.81,
    x2: 171.69,
    y2: 126.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.9288,
    y1: 94.8849,
    x2: 200.7041,
    y2: 116.2472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2442,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4653,
    style: {
      stopColor: "#F0F0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6776,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8831,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B2B2"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M229.39,104.8c-1.04-0.58-7.34-5.91-16.35-11.48c-9.36-5.79-17.1-0.26-23.74,10.55 c-3.14,5.07-6.38,9.98-10.3,15.16c-3.2,4.23-6.72,7.27-7.31,7.78L229.39,104.8z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M113.98,80.34H64.89c-7.13,0-12.91-5.78-12.91-12.91c0-7.13,5.78-12.91,12.91-12.91h33.75L83.83,29.59H62.05 c-20.77,0-37.61,16.84-37.61,37.61c0,20.77,16.84,37.61,37.61,37.61h66.47L113.98,80.34z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "212.62,29.56 183.81,29.56 154.28,80.99 124.01,29.56 96.29,29.59 139.53,104.9 168.34,104.9  168.32,104.86 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M246.91,82.46c1.78-0.3,3.89-0.5,6.2-0.5c4.19,0,7.17,1,9.14,2.81c2.04,1.84,3.22,4.46,3.22,8.11 c0,3.68-1.17,6.7-3.25,8.78c-2.14,2.11-5.63,3.25-10.01,3.25c-2.11,0-3.82-0.1-5.29-0.27V82.46z M249.83,102.43 c0.74,0.1,1.81,0.13,2.95,0.13c6.26,0,9.61-3.48,9.61-9.58c0.03-5.33-2.98-8.71-9.14-8.71c-1.51,0-2.65,0.13-3.42,0.3V102.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.57,82.43c1.47-0.27,3.62-0.47,5.59-0.47c3.11,0,5.16,0.6,6.53,1.84c1.1,1,1.77,2.54,1.77,4.32 c0,2.95-1.88,4.92-4.22,5.73v0.1c1.71,0.6,2.75,2.21,3.28,4.55c0.74,3.15,1.27,5.33,1.74,6.2h-3.01c-0.37-0.67-0.87-2.58-1.47-5.39 c-0.67-3.11-1.91-4.29-4.56-4.39h-2.75v9.78h-2.91V82.43z M274.48,92.71h2.98c3.12,0,5.09-1.71,5.09-4.29 c0-2.91-2.11-4.19-5.19-4.19c-1.41,0-2.38,0.1-2.88,0.23V92.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.85,82.13v13.4c0,5.02,2.24,7.17,5.26,7.17c3.32,0,5.49-2.21,5.49-7.17v-13.4h2.95v13.2c0,6.93-3.65,9.75-8.54,9.75 c-4.62,0-8.11-2.61-8.11-9.65v-13.3H294.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.7,104c-1.04,0.54-3.21,1.07-5.96,1.07c-6.36,0-11.12-4.02-11.12-11.45c0-7.1,4.79-11.86,11.79-11.86 c2.78,0,4.59,0.6,5.36,1l-0.74,2.38c-1.07-0.54-2.65-0.94-4.52-0.94c-5.29,0-8.81,3.38-8.81,9.31c0,5.56,3.18,9.08,8.64,9.08 c1.81,0,3.62-0.37,4.79-0.94L331.7,104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,82.13h2.91v10.88h0.1c0.6-0.87,1.21-1.67,1.78-2.41l6.9-8.47h3.62l-8.17,9.58l8.81,13h-3.45l-7.4-11.09l-2.18,2.48 v8.61h-2.91V82.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.86,101.15c1.31,0.84,3.18,1.47,5.19,1.47c2.98,0,4.72-1.57,4.72-3.85c0-2.08-1.21-3.32-4.25-4.45 c-3.68-1.34-5.96-3.28-5.96-6.43c0-3.52,2.91-6.13,7.3-6.13c2.28,0,3.99,0.54,4.96,1.1l-0.8,2.38c-0.7-0.44-2.21-1.07-4.25-1.07 c-3.08,0-4.25,1.84-4.25,3.38c0,2.11,1.37,3.15,4.49,4.35c3.82,1.47,5.73,3.32,5.73,6.63c0,3.48-2.54,6.53-7.87,6.53 c-2.18,0-4.56-0.67-5.76-1.47L357.86,101.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.12,104.7v-9.58l-7.17-13h3.35l3.18,6.23c0.84,1.71,1.54,3.08,2.24,4.66h0.07c0.6-1.47,1.41-2.95,2.28-4.66l3.25-6.23 h3.28l-7.54,12.96v9.61H382.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76,101.15c1.31,0.84,3.18,1.47,5.19,1.47c2.98,0,4.72-1.57,4.72-3.85c0-2.08-1.21-3.32-4.25-4.45 c-3.68-1.34-5.96-3.28-5.96-6.43c0-3.52,2.91-6.13,7.3-6.13c2.28,0,3.99,0.54,4.96,1.1l-0.8,2.38c-0.7-0.44-2.21-1.07-4.25-1.07 c-3.08,0-4.25,1.84-4.25,3.38c0,2.11,1.37,3.15,4.49,4.35c3.82,1.47,5.73,3.32,5.73,6.63c0,3.48-2.54,6.53-7.87,6.53 c-2.18,0-4.56-0.67-5.76-1.47L396.76,101.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.27,84.61h-6.87v-2.48h16.71v2.48h-6.9v20.1h-2.95V84.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.64,94.12h-8.74v8.14h9.78v2.45h-12.73V82.13h12.23v2.45h-9.28v7.13h8.74V94.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.83,94.79c-0.17-3.15-0.37-6.97-0.37-9.75h-0.07c-0.8,2.61-1.71,5.46-2.85,8.57l-3.99,10.95h-2.21l-3.68-10.75 c-1.07-3.22-1.94-6.1-2.58-8.78h-0.07c-0.07,2.81-0.23,6.56-0.44,9.98l-0.6,9.68h-2.78l1.57-22.57h3.72l3.85,10.92 c0.94,2.78,1.67,5.26,2.28,7.6h0.07c0.6-2.28,1.41-4.76,2.41-7.6l4.02-10.92h3.72l1.41,22.57h-2.88L472.83,94.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.74,94.12H486v8.14h9.78v2.45h-12.73V82.13h12.23v2.45H486v7.13h8.74V94.12z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValentin);
export default __webpack_public_path__ + "static/media/VALENTIN.44242c5bf0632725ba3fdb01ddd7c254.svg";
export { ForwardRef as ReactComponent };